import { isMobileQuery, cdnService, SessionMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { BREAKPOINT_DEVICE_UPDATED } from '@gig/magic-messages';
import '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import { LandingPageMixin } from '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

/**
 * Component displaying full landing page
 */
var LandingComponent = /** @class */ (function (_super) {
    __extends(LandingComponent, _super);
    function LandingComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Whether current viewport is mobile.
         * Used to display mobile background if available
         */
        _this.isMobile = false;
        _this.hideSignUp = false;
        _this.breakpointSubscription = null;
        return _this;
    }
    LandingComponent.prototype.created = function () {
        var _this = this;
        this.breakpointSubscription = window.eventBus.subscribe(BREAKPOINT_DEVICE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!event.payload) {
                            return [2 /*return*/, null];
                        }
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        _a.isMobile = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    LandingComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.breakpointSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Object.defineProperty(LandingComponent.prototype, "landingPage", {
        get: function () {
            var _this = this;
            var _a;
            var pageSlug = (_a = this.landingPages) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                var slug = _a.slug;
                return slug === _this.slug;
            });
            return pageSlug || null;
        },
        enumerable: false,
        configurable: true
    });
    LandingComponent.prototype.checkForPromoType = function () {
        var page = this.landingPage;
        if (page) {
            this.hideSignUp = page.types.some(function (type) {
                return type.match('landing no signup');
            });
            this.hideSignUpForm();
        }
    };
    Object.defineProperty(LandingComponent.prototype, "background", {
        get: function () {
            if (!this.landingPage || !this.landingPage.background) {
                return null;
            }
            // always get background in original size
            var imageParams = {
                width: 1,
                height: 1,
            };
            if (this.isMobile && this.landingPage.mobileBackground) {
                return cdnService.getLandingMobileBackgroundUrl(this.landingPage.mobileBackground, imageParams);
            }
            return cdnService.getLandingBackgroundUrl(this.landingPage.background, imageParams);
        },
        enumerable: false,
        configurable: true
    });
    LandingComponent.prototype.onLandingsLoad = function () {
        if (!this.isLoading &&
            this.landingPages.length > 0 &&
            !this.landingPage) {
            this.handleNotFound();
            return;
        }
        this.checkForPromoType();
    };
    /**
     * Emitted when no promotion was found for given slug and type
     */
    LandingComponent.prototype.handleNotFound = function () {
        return;
    };
    LandingComponent.prototype.hideSignUpForm = function () {
        return this.hideSignUp;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], LandingComponent.prototype, "slug", void 0);
    __decorate([
        Watch('isLoading', { immediate: true }),
        Watch('landingPages'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LandingComponent.prototype, "onLandingsLoad", null);
    __decorate([
        Emit('notFound'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LandingComponent.prototype, "handleNotFound", null);
    __decorate([
        Emit('hideLandingSignUp'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], LandingComponent.prototype, "hideSignUpForm", null);
    LandingComponent = __decorate([
        Component({
            name: 'landing-page',
        })
    ], LandingComponent);
    return LandingComponent;
}(Mixins(LandingPageMixin, SessionMixin)));

export default LandingComponent;
